import {AxiosRequestConfig, AxiosResponse} from 'axios'
import {ExceptionError} from '../exception'
import {Request} from '../request'
import {ICompany, ICompanyCreate, ICompanyUpdate} from '../../interface/company/company'
import {IPageOption} from '../../interface/paging/paging'
import {IApiResponse} from '../../interface/api-response/api-response'
import {API_PATH} from '../../constants/api-path'
import {IUser} from '../../interface/user/user'

export class GetCompanyService extends Request {
  async request(options?: IPageOption) {
    try {
      const {data} = await this.client
        .get<IApiResponse<ICompany[]>>(API_PATH.COMPANY, {
          params: options,
        })
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class CreateCompanyService extends Request {
  async request(payload: ICompanyCreate) {
    const {data} = await this.client.post<ICompany>(API_PATH.COMPANY, payload)
    try {
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class UpdateCompanyService extends Request {
  async request(payload: ICompanyUpdate) {
    try {
      const {data} = await this.client.patch<ICompany>(API_PATH.COMPANY, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class DeleteCompanyService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .delete<IApiResponse<any>>(`${API_PATH.COMPANY}/${id}`)
        .then((d) => d.data)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetMyInfoService extends Request {
  async request() {
    try {
      const {data} = await this.client
        .get<IApiResponse<IUser>>(`${API_PATH.USER}/me`)
        .then((d) => d.data)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetCompanybyCompanyGroupIdService extends Request {
  async request(params, companyGroupId: string) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.COMPANY}/get-by-company-group/${companyGroupId}`, {
          params,
        })
        .then((d) => d.data)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetCompanyLogService extends Request {
  async request(params: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.COMPANY}/get-log/${params.id}`, {params})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
